import { render } from "./reabrir_atendimento.vue?vue&type=template&id=40919fb4"
import script from "./reabrir_atendimento.vue?vue&type=script&lang=js"
export * from "./reabrir_atendimento.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__